import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rank' })
export class RankPipe implements PipeTransform {
    transform(value: number): string {
        return `#${value.toFixed(0)}`;
    }
}
